import React from 'react';

interface ConfirmationDialogProps {
    onConfirm: () => void;
    onCancel: () => void;
    confirmButtonText: string;
    cancelButtonText: string;
    title: string;
    message: string;
    message2?: string | null;
}

const ConfirmationDialog = ({
    onConfirm,
    onCancel,
    confirmButtonText,
    cancelButtonText,
    title,
    message,
    message2
}: ConfirmationDialogProps): JSX.Element => (
    <div className="dialog-backdrop w-full h-full fixed top-0 left-0 flex justify-center items-center bg-gray-600 bg-opacity-50 z-50">
        <div className="dialog w-full max-w-4xl mx-auto p-8 bg-white rounded-lg shadow-xl">
            <h2 className="text-lg font-bold text-center">{title}</h2>
            <p className="mt-4 text-center">{message}</p>
            {message2 && (
            <p className="mt-4 text-center">{message2}</p>
            )}
            <div className="dialog-actions flex justify-center space-x-4 mt-6">
                <button onClick={onConfirm} className="button">
                    {confirmButtonText}
                </button>
                <button onClick={onCancel} className="text-center border text-[#171717] font-[600] bg-[#fff] px-[34px] hover:bg-[#fff] border-[#00000033] rounded-[6px] h-[36px] transition">
                    {cancelButtonText}
                </button>
            </div>
        </div>
    </div>
);

export default ConfirmationDialog;
